import {
  JOTTER_FULFILLED,
  JOTTER_PENDING,
  JOTTER_REJECTED,
} from 'redux/modules/multi-search/actions/types';

import { getJotterStorage } from 'redux/modules/multi-search/selectors/get-jotter-storage';

/**
 * The jotter is the local storage backed store for multi-search so that when you click the multi-search CTA and it opens the modal your previous search terms are populated.
 *
 * Any page with the header searchbar needs this jotter.
 */
export const jotterFetcher = () => (dispatch, getState) => {
  dispatch({ type: JOTTER_PENDING });

  const jotterStorage = getJotterStorage(getState());
  const values = jotterStorage.get();

  return values
    ? dispatch({ type: JOTTER_FULFILLED, payload: values })
    : dispatch({ type: JOTTER_REJECTED });
};
